export default {
  displayName: 'Rainbarrier Comparison Table',
  allowableParents: ['Section'],
};
